import { App, Button, Popconfirm, Popover, Space } from 'antd';
import React, { useState } from 'react';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../services/react-query/queryKeys';
import {
  deleteInsurancePayors,
  getInsurancePayors,
} from '../../network/insurancePayor';

const InsurancePayor = ({ t }) => {
  const client = useQueryClient();
  const { currentLang } = useSelector((state) => state.user);
  const [searchText, setSearchText] = useState('');
  const navigate = useNavigate();
  const { message } = App.useApp();
  const handleRemove = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (id) => deleteInsurancePayors(id),
      onSuccess: (data) => {
        // console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message);
          return false;
        }
        message.success(data?.message || 'تم الحذف بنجاح');
        // message.success('تم الحذف بنجاح');
        client.invalidateQueries({ queryKey: [queryKeys.getInsurancePayors] });
      },
      onError: () => {
        message.error('حدث خطأ ما');
      },
    }
  );
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getInsurancePayors],
    queryFn: () => getInsurancePayors(),
    keepPreviousData: true,
  });
  const columns = [
    {
      title:
        currentLang === 'en'
          ? 'Insurance Company Name'
          : 'اسم الشركة التأمينية',
      dataIndex: 'insurance_payor_name',
      // dataIndex: 'name',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        const name = String(record.insurance_payor_name).toLowerCase();
        const searchValue = value.toLowerCase();
        // console.log(record);
        return name.includes(searchValue);
      },
    },
    {
      title:
        currentLang === 'en'
          ? 'Insurance Claim Credit Days'
          : 'أيام الدفع التأمين',
      dataIndex: 'insurance_claim_credit_days',
    },
    // {
    //   title: currentLang === 'en' ? 'Medical Code Standard' : 'الكود الطبي',
    //   dataIndex: 'medical_code_standard',
    // },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: '150px',
      render: (text, record) => {
        // console.log('record:', record);
        return (
          <Space>
            <Button
              size="small"
              type="primary"
              onClick={() => navigate(`/insurance_payor/${record.name}`)}
              icon={<MdModeEditOutline />}
            />
            <Popconfirm
              title={t.DeletetheInsurancePayor}
              description={t.areYouSure}
              onConfirm={() => handleRemove.mutate(record.name)}
              // onCancel={cancel}
              okText={t.yes}
              cancelText={t.no}
            >
              <Button size="small" type="primary" danger icon={<MdDelete />} />
            </Popconfirm>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => ({
    key: index,
    ...item,
  }));
  return (
    <div className="InsurancePayor">
      <Heading title={t.Insurances} subTitle={t.InsurancePayor} path="/" />
      <DynamicTableAnt
        columns={columns}
        data={dataTable}
        loading={isLoading}
        lang={currentLang}
        setSearchText={setSearchText}
        titleBtn={t.AddInsurancePayor}
        Placeholder={t.SearchInsurancePayor}
        pathBtn="/insurance_payor/add"
      />
    </div>
  );
};

export default InsurancePayor;
